/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Prep_KickerInputs */

const en_plan_prep_kicker = /** @type {(inputs: Plan_Prep_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prep ahead`)
};

const de_plan_prep_kicker = /** @type {(inputs: Plan_Prep_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorbereiten`)
};

/**
* | output |
* | --- |
* | "Prep ahead" |
*
* @param {Plan_Prep_KickerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_prep_kicker = /** @type {((inputs?: Plan_Prep_KickerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Prep_KickerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_prep_kicker(inputs)
	return en_plan_prep_kicker(inputs)
});